import Vue from 'vue'
import VueGtag from 'vue-gtag';

import App from './App.vue'
import router from './router'

import reddit from "@/utils/reddit"
import settings from "@/utils/settings"

//Add icons from font awesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { faSearch, faCog, faBars, faShoppingCart } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faSearch)
library.add(faCog)
library.add(faBars)
library.add(faShoppingCart)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

Vue.use(VueGtag, {
    config: {
      id: "UA-164424750-1"
    }
  }, router);

new Vue({
  router,
  render: h => h(App),
  beforeCreate() {
    //Start authorizing client as early as possible
    const userAgent = `browser:dedup-web:${settings.getAppVersion()} (by /u/iwinulose)`
    const clientID = "cbhGws5He_gnLA"
    var deviceID = settings.getDeviceID()
    reddit.setupSharedClient(userAgent, clientID, deviceID)
  },
  methods: {
    sanitizeSearchString(string) {
      // Trim whitespace
      let ret = string.trim()

      // Remove trailing slashes
      while (ret.endsWith('/')) {
        ret = ret.slice(0, -1)
      }

      // Remove repeated slashes
      while (ret.indexOf("//") != -1) {
        ret = ret.replace("//", "/")
      }

      return ret
    },
    filterPrefixes(string, filteredPrefixes) {
      let ret = string
      let lowerCaseString = string.toLowerCase()
      for( let i = 0; i < filteredPrefixes.length; i++ ) {
        let prefix = filteredPrefixes[i]
        if (lowerCaseString.startsWith(prefix)) {
          ret = string.substring(prefix.length)
          break
        }
      }
      return ret
    },
    handleSearch(searchString) {
      this.$gtag.event('search', { search_term: searchString })
      let sanitizedSearchString = this.sanitizeSearchString(searchString)
      if( sanitizedSearchString.toLowerCase().indexOf("u/") != -1 ) {
          this.goToUser(sanitizedSearchString)
        }
        else {
          this.goToSubreddit(sanitizedSearchString)
        }
    },
    goToUser(username) {
      username = this.filterPrefixes(username, ['/u/', 'u/'])
      this.$router.push({
        name: "User",
        params: { username: username }
      })
    },
    goToSubreddit(subreddit) {
      subreddit = this.filterPrefixes(subreddit, ['/r/', 'r/'])
      this.$router.push({
        name: "Subreddit",
        params: { subreddit: subreddit }
      })
    }
  }
}).$mount('#app')
